import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NbIconModule, NbPopoverModule, NbSpinnerModule } from '@nebular/theme'
import { NbEvaIconsModule } from '@nebular/eva-icons'

import { StorageBadgeComponent } from './storage-badge.component'

@NgModule({
  declarations: [ StorageBadgeComponent ],
  imports: [ CommonModule, NbIconModule, NbEvaIconsModule, NbPopoverModule, NbSpinnerModule ],
  exports: [ StorageBadgeComponent ]
})
export class StorageBadgeModule {}
